var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_6888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3874 28.8209V12.5087C35.3874 11.4222 34.5233 10.3464 33.4612 10.1103L9.85421 4.86434C9.26335 4.73304 8.73378 4.88887 8.38015 5.24002L8.36706 5.25318L7.69841 5.92589C7.37238 6.20652 7.17224 6.63797 7.17224 7.16082V23.4731C7.17224 24.5596 8.03635 25.6354 9.0985 25.8714L32.7055 31.1174C33.271 31.2431 33.7803 31.1057 34.133 30.7858L34.2278 30.6914L34.9004 30.0209L34.9727 29.9488C35.2323 29.6707 35.3874 29.2812 35.3874 28.8209ZM9.0985 6.87623C8.71432 6.79085 8.40177 7.04108 8.40177 7.43404V10.7038L33.4022 16.2595V12.9897C33.4022 12.5967 33.0896 12.2076 32.7055 12.1222L9.0985 6.87623ZM33.4022 17.5171L8.40177 11.9615V23.7463C8.40177 24.1393 8.71432 24.5284 9.0985 24.6138L32.7055 29.8598C33.0896 29.9452 33.4022 29.6949 33.4022 29.302V17.5171Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40177 11.9615L33.4022 17.5171V29.302C33.4022 29.6949 33.0896 29.9452 32.7055 29.8598L9.0985 24.6138C8.71432 24.5284 8.40177 24.1393 8.40177 23.7463V11.9615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40177 7.43404C8.40177 7.04108 8.71432 6.79085 9.0985 6.87623L32.7055 12.1222C33.0896 12.2076 33.4022 12.5967 33.4022 12.9897V16.2595L8.40177 10.7038V7.43404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.755713 35.9595V45.727L9.42639 47.6538V42.2041L10.1821 42.3721V41.4499L11.9674 41.8466V39.4151C11.9674 38.3519 11.1217 37.2989 10.0821 37.0679L1.84429 35.2372C1.492 35.1589 1.16245 35.1873 0.882165 35.301C0.800546 35.4957 0.755713 35.7174 0.755713 35.9595ZM8.95257 37.823V46.2909L8.19686 46.123V47.0452L1.22953 45.4969V36.987C1.22953 36.6403 1.50527 36.4195 1.84429 36.4948L1.98524 36.5262V36.2328C1.98524 35.886 2.26098 35.6652 2.60001 35.7406L9.07044 37.1784C8.99438 37.3706 8.95257 37.5872 8.95257 37.823ZM10.1821 38.0962C10.1821 37.7264 10.4763 37.4909 10.8378 37.5712C11.1994 37.6516 11.4936 38.0178 11.4936 38.3877V40.4837L10.7379 40.3157V41.2379L9.42639 40.9465V38.8505C9.42639 38.4807 9.72057 38.2451 10.0821 38.3255C10.1161 38.333 10.1495 38.3431 10.1821 38.3555V38.0962Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7231 42.0145L11.9674 41.8466V42.7688L12.7231 42.0145Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42639 47.6538V48.576L10.1821 47.8218L9.42639 47.6538Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.473518 35.5583C0.592387 35.4496 0.730017 35.3627 0.882165 35.301C0.954952 35.1273 1.05699 34.975 1.18259 34.8487L0.473518 35.5583Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8378 36.3136L2.60001 34.483C2.03091 34.3565 1.52117 34.5082 1.18259 34.8487C1.05699 34.975 0.954952 35.1273 0.882165 35.301C0.730017 35.3627 0.592387 35.4496 0.473518 35.5583C0.443416 35.5858 0.414517 35.6147 0.386891 35.645C0.144479 35.9104 0 36.2791 0 36.7138V46.4813L9.42639 48.576V47.6538L10.1821 47.8218V42.3721L11.9674 42.7688V41.8466L12.7231 42.0145V38.6609C12.7231 37.5976 11.8775 36.5446 10.8378 36.3136ZM11.9674 41.8466L10.1821 41.4499V42.3721L9.42639 42.2041V47.6538L0.755713 45.727V35.9595C0.755713 35.7174 0.800546 35.4957 0.882165 35.301C1.16245 35.1873 1.492 35.1589 1.84429 35.2372L10.0821 37.0679C11.1217 37.2989 11.9674 38.3519 11.9674 39.4151V41.8466ZM1.98524 36.2328V36.5262L8.31473 37.9327C8.23866 38.1248 8.19686 38.3415 8.19686 38.5772V46.123L8.95257 46.2909V37.823C8.95257 37.5872 8.99438 37.3706 9.07044 37.1784L2.60001 35.7406C2.26098 35.6652 1.98524 35.886 1.98524 36.2328ZM10.1821 38.3555V38.0962C10.1821 37.7264 10.4763 37.4909 10.8378 37.5712C11.1994 37.6516 11.4936 38.0178 11.4936 38.3877V40.4837L10.7379 40.3157V39.1419C10.7379 38.8069 10.4964 38.4747 10.1821 38.3555Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22953 45.4969L8.19686 47.0452V46.123V38.5772C8.19686 38.3415 8.23866 38.1248 8.31473 37.9327L1.98524 36.5262L1.84429 36.4948C1.50527 36.4195 1.22953 36.6403 1.22953 36.987V45.4969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42639 40.9465L10.7379 41.2379V40.3157V39.1419C10.7379 38.8069 10.4964 38.4747 10.1821 38.3555C10.1495 38.3431 10.1161 38.333 10.0821 38.3255C9.72057 38.2451 9.42639 38.4807 9.42639 38.8505V40.9465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.702 39.3094V49.0769L24.3727 51.0037V45.554L25.1284 45.7219V44.7997L26.9137 45.1964V42.765C26.9137 41.7017 26.0681 40.6487 25.0285 40.4177L16.7906 38.5871C16.4383 38.5088 16.1088 38.5371 15.8285 38.6508C15.7469 38.8456 15.702 39.0673 15.702 39.3094ZM23.8989 41.1728V49.6408L23.1432 49.4728V50.395L16.1758 48.8467V40.3369C16.1758 39.9901 16.4516 39.7694 16.7906 39.8447L16.9316 39.876V39.5826C16.9316 39.2359 17.2073 39.0151 17.5463 39.0904L24.0168 40.5283C23.9407 40.7204 23.8989 40.9371 23.8989 41.1728ZM25.1284 41.4461C25.1284 41.0762 25.4226 40.8407 25.7842 40.9211C26.1457 41.0014 26.4399 41.3677 26.4399 41.7375V43.8335L25.6842 43.6656V44.5878L24.3727 44.2964V42.2003C24.3727 41.8305 24.6669 41.595 25.0285 41.6753C25.0624 41.6829 25.0958 41.6929 25.1284 41.7053V41.4461Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6694 45.3644L26.9137 45.1964V46.1186L27.6694 45.3644Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3727 51.0037V51.9259L25.1284 51.1716L24.3727 51.0037Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4198 38.9081C15.5387 38.7995 15.6763 38.7126 15.8285 38.6508C15.9013 38.4772 16.0033 38.3249 16.1289 38.1986L15.4198 38.9081Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7842 39.6634L17.5463 37.8328C16.9772 37.7063 16.4675 37.8581 16.1289 38.1986C16.0033 38.3249 15.9013 38.4772 15.8285 38.6508C15.6763 38.7126 15.5387 38.7995 15.4198 38.9081C15.3897 38.9356 15.3608 38.9646 15.3332 38.9948C15.0908 39.2603 14.9463 39.629 14.9463 40.0637V49.8311L24.3727 51.9259V51.0037L25.1284 51.1716V45.7219L26.9137 46.1186V45.1964L27.6694 45.3644V42.0107C27.6694 40.9475 26.8238 39.8945 25.7842 39.6634ZM26.9137 45.1964L25.1284 44.7997V45.7219L24.3727 45.554V51.0037L15.702 49.0769V39.3094C15.702 39.0673 15.7469 38.8456 15.8285 38.6508C16.1088 38.5371 16.4383 38.5088 16.7906 38.5871L25.0285 40.4177C26.0681 40.6487 26.9137 41.7017 26.9137 42.765V45.1964ZM16.9316 39.5826V39.876L23.261 41.2826C23.185 41.4747 23.1432 41.6913 23.1432 41.9271V49.4728L23.8989 49.6408V41.1728C23.8989 40.9371 23.9407 40.7204 24.0168 40.5283L17.5463 39.0904C17.2073 39.0151 16.9316 39.2359 16.9316 39.5826ZM25.1284 41.7053V41.4461C25.1284 41.0762 25.4226 40.8407 25.7842 40.9211C26.1457 41.0014 26.4399 41.3677 26.4399 41.7375V43.8335L25.6842 43.6656V42.4918C25.6842 42.1567 25.4427 41.8245 25.1284 41.7053Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1758 48.8467L23.1432 50.395V49.4728V41.9271C23.1432 41.6913 23.185 41.4747 23.261 41.2826L16.9316 39.876L16.7906 39.8447C16.4516 39.7694 16.1758 39.9901 16.1758 40.3369V48.8467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3727 44.2964L25.6842 44.5878V43.6656V42.4918C25.6842 42.1567 25.4427 41.8245 25.1284 41.7053C25.0958 41.6929 25.0624 41.6829 25.0285 41.6753C24.6669 41.595 24.3727 41.8305 24.3727 42.2003V44.2964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6484 42.6592V52.4267L39.319 54.3535V48.9038L40.0747 49.0718V48.1496L41.8601 48.5463V46.1149C41.8601 45.0516 41.0144 43.9986 39.9748 43.7676L31.7369 41.9369C31.3846 41.8586 31.0551 41.887 30.7748 42.0007C30.6932 42.1954 30.6484 42.4171 30.6484 42.6592ZM38.8452 44.5227V52.9906L38.0895 52.8227V53.7449L31.1222 52.1966V43.6867C31.1222 43.34 31.3979 43.1192 31.7369 43.1945L31.8779 43.2259V42.9325C31.8779 42.5857 32.1536 42.3649 32.4926 42.4403L38.9631 43.8782C38.887 44.0703 38.8452 44.2869 38.8452 44.5227ZM40.0747 44.7959C40.0747 44.4261 40.3689 44.1906 40.7305 44.2709C41.0921 44.3513 41.3862 44.7175 41.3862 45.0874V47.1834L40.6305 47.0155V47.9377L39.319 47.6462V45.5502C39.319 45.1804 39.6132 44.9448 39.9748 45.0252C40.0088 45.0327 40.0421 45.0428 40.0747 45.0552V44.7959Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6158 48.7142L41.8601 48.5463V49.4685L42.6158 48.7142Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.319 54.3535V55.2757L40.0747 54.5215L39.319 54.3535Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3662 42.258C30.485 42.1493 30.6227 42.0624 30.7748 42.0007C30.8476 41.827 30.9496 41.6747 31.0752 41.5484L30.3662 42.258Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7305 43.0133L32.4926 41.1827C31.9236 41.0562 31.4138 41.2079 31.0752 41.5484C30.9496 41.6747 30.8476 41.827 30.7748 42.0007C30.6227 42.0624 30.485 42.1493 30.3662 42.258C30.3361 42.2855 30.3072 42.3144 30.2795 42.3447C30.0371 42.6101 29.8926 42.9788 29.8926 43.4135V53.181L39.319 55.2757V54.3535L40.0747 54.5215V49.0718L41.8601 49.4685V48.5463L42.6158 48.7142V45.3606C42.6158 44.2973 41.7701 43.2443 40.7305 43.0133ZM41.8601 48.5463L40.0747 48.1496V49.0718L39.319 48.9038V54.3535L30.6484 52.4267V42.6592C30.6484 42.4171 30.6932 42.1954 30.7748 42.0007C31.0551 41.887 31.3846 41.8586 31.7369 41.9369L39.9748 43.7676C41.0144 43.9986 41.8601 45.0516 41.8601 46.1149V48.5463ZM31.8779 42.9325V43.2259L38.2074 44.6324C38.1313 44.8245 38.0895 45.0412 38.0895 45.277V52.8227L38.8452 52.9906V44.5227C38.8452 44.2869 38.887 44.0703 38.9631 43.8782L32.4926 42.4403C32.1536 42.3649 31.8779 42.5857 31.8779 42.9325ZM40.0747 45.0552V44.7959C40.0747 44.4261 40.3689 44.1906 40.7305 44.2709C41.0921 44.3513 41.3862 44.7175 41.3862 45.0874V47.1834L40.6305 47.0155V45.8416C40.6305 45.5066 40.389 45.1744 40.0747 45.0552Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1222 52.1966L38.0895 53.7449V52.8227V45.277C38.0895 45.0412 38.1313 44.8245 38.2074 44.6324L31.8779 43.2259L31.7369 43.1945C31.3979 43.1192 31.1222 43.34 31.1222 43.6867V52.1966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.319 47.6462L40.6305 47.9377V47.0155V45.8416C40.6305 45.5066 40.389 45.1744 40.0747 45.0552C40.0421 45.0428 40.0088 45.0327 39.9748 45.0252C39.6132 44.9448 39.319 45.1804 39.319 45.5502V47.6462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27223 30.0716L36.0432 36.4652V40.3638L36.517 40.4691L37.2727 40.637V35.4808L22.2725 32.1474V29.171L21.043 28.8978V29.8201V31.8742L6.0427 28.5408V29.463V33.697L6.51652 33.8023L7.27223 33.9702V30.0716Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51652 30.8259L35.2875 37.2195V41.1181L36.517 41.3913V40.4691V36.2351L21.5168 32.9017V29.9254L21.043 29.8201L20.2872 29.6521V32.6285L6.0427 29.463L5.28699 29.2951V34.4513L6.51652 34.7245V33.8023V30.8259Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27223 33.9702L6.51652 33.8023V34.7245L7.27223 33.9702Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0427 29.463V28.5408L5.28699 29.2951L6.0427 29.463Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.043 29.8201V28.8978L20.2872 29.6521L21.043 29.8201Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2727 40.637L36.517 40.4691V41.3913L37.2727 40.637Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 38.0916L7.18624 38.893V40.1506L6.43053 39.9827L3.57963 39.3492V39.0139V38.0916Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82391 38.8459L3.57963 39.0139L6.43053 39.6474V39.9827V40.905L2.82391 40.1035V38.8459Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 39.0139V38.0916L2.82391 38.8459L3.57963 39.0139Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18624 40.1506L6.43053 39.9827V40.905L7.18624 40.1506Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 40.439L7.18624 41.2404V42.4981L6.43053 42.3301L3.57963 41.6966V41.3613V40.439Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82391 41.1933L3.57963 41.3613L6.43053 41.9948V42.3301V43.2524L2.82391 42.451V41.1933Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18624 42.4981L6.43053 42.3301V43.2524L7.18624 42.4981Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 41.3613V40.439L2.82391 41.1933L3.57963 41.3613Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 42.7866L7.18624 43.5881V44.8457L6.43053 44.6778L3.57963 44.0442V43.7089V42.7866Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82391 43.541L3.57963 43.7089L6.43053 44.3425V44.6778V45.6001L2.82391 44.7986V43.541Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18624 44.8457L6.43053 44.6778V45.6001L7.18624 44.8457Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57963 43.7089V42.7866L2.82391 43.541L3.57963 43.7089Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 41.4412L22.1326 42.2426V43.5003L21.3769 43.3323L18.5259 42.6988V42.3635V41.4412Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7702 42.1955L18.5259 42.3635L21.3769 42.997V43.3323V44.2546L17.7702 43.4532V42.1955Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 42.3635V41.4412L17.7702 42.1955L18.5259 42.3635Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1326 43.5003L21.3769 43.3323V44.2546L22.1326 43.5003Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 44.791L37.0789 45.5925V46.8501L36.3232 46.6822L33.4723 46.0486V45.7133V44.791Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7166 45.5454L33.4723 45.7133L36.3232 46.3469V46.6822V47.6045L32.7166 46.803V45.5454Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 45.7133V44.791L32.7166 45.5454L33.4723 45.7133Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0789 46.8501L36.3232 46.6822V47.6045L37.0789 46.8501Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 43.7888L22.1326 44.5903V45.8479L21.3769 45.68L18.5259 45.0464V44.7111V43.7888Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7702 44.5432L18.5259 44.7111L21.3769 45.3447V45.68V46.6023L17.7702 45.8008V44.5432Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1326 45.8479L21.3769 45.68V46.6023L22.1326 45.8479Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 44.7111V43.7888L17.7702 44.5432L18.5259 44.7111Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 47.1387L37.0789 47.9402V49.1978L36.3232 49.0298L33.4723 48.3963V48.061V47.1387Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7166 47.893L33.4723 48.061L36.3232 48.6945V49.0298V49.9521L32.7166 49.1507V47.893Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0789 49.1978L36.3232 49.0298V49.9521L37.0789 49.1978Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 48.061V47.1387L32.7166 47.893L33.4723 48.061Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 46.1362L22.1326 46.9377V48.1953L21.3769 48.0274L18.5259 47.3939V47.0585V46.1362Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7702 46.8906L18.5259 47.0585L21.3769 47.6921V48.0274V48.9497L17.7702 48.1482V46.8906Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1326 48.1953L21.3769 48.0274V48.9497L22.1326 48.1953Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 47.0585V46.1362L17.7702 46.8906L18.5259 47.0585Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 49.4861L37.0789 50.2876V51.5452L36.3232 51.3772L33.4723 50.7437V50.4084V49.4861Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7166 50.2405L33.4723 50.4084L36.3232 51.0419V51.3772V52.2995L32.7166 51.4981V50.2405Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0789 51.5452L36.3232 51.3772V52.2995L37.0789 51.5452Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4723 50.4084V49.4861L32.7166 50.2405L33.4723 50.4084Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9529 11.7493L30.1824 12.0225V13.2801L29.4267 13.1122L28.9529 13.0069V12.6715V11.7493Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1972 12.5036L28.9529 12.6715L29.4267 12.7768V13.1122V14.0344L28.1972 13.7612V12.5036Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9529 12.6715V11.7493L28.1972 12.5036L28.9529 12.6715Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1824 13.2801L29.4267 13.1122V14.0344L30.1824 13.2801Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.412 12.2959L32.6415 12.5691V13.8268L31.8858 13.6588L31.412 13.5535V13.2181V12.2959Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6562 13.0502L31.412 13.2181L31.8858 13.3234V13.6588V14.581L30.6562 14.3078V13.0502Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.412 13.2181V12.2959L30.6562 13.0502L31.412 13.2181Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6415 13.8268L31.8858 13.6588V14.581L32.6415 13.8268Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8379 7.72389L27.7234 11.4762V12.7338L26.9677 12.5659L10.8379 8.9815V8.6461V7.72389Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0822 8.47816L10.8379 8.6461L26.9677 12.2305V12.5659V13.4881L10.0822 9.73578V8.47816Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8379 8.6461V7.72389L10.0822 8.47816L10.8379 8.6461Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7234 12.7338L26.9677 12.5659V13.4881L27.7234 12.7338Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5085 16.1902L11.7395 14.4637L10.9838 14.2958V23.0152L19.5085 24.9096V23.9874V16.1902ZM18.279 23.3788L12.2133 22.0309V15.8266L18.279 17.1746V23.3788Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2642 15.4359L11.7395 13.5415L10.9838 14.2958L11.7395 14.4637L19.5085 16.1902V23.9874V24.9096L20.2642 24.1554V15.4359Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.279 23.3788L12.2133 22.0309V15.8266L18.279 17.1746V23.3788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 15.773L31.7808 17.9952V19.2528L31.0251 19.0849L21.7807 17.0306V16.6952V15.773Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.025 16.5272L21.7807 16.6952L31.0251 18.7495V19.0849V20.0071L21.025 17.7848V16.5272Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7808 19.2528L31.0251 19.0849V20.0071L31.7808 19.2528Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 16.6952V15.773L21.025 16.5272L21.7807 16.6952Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 19.5127L31.7808 21.735V22.9926L31.0251 22.8246L21.7807 20.7703V20.4349V19.5127Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.025 20.267L21.7807 20.4349L31.0251 22.4892V22.8246V23.7468L21.025 21.5246V20.267Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7808 22.9926L31.0251 22.8246V23.7468L31.7808 22.9926Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 20.4349V19.5127L21.025 20.267L21.7807 20.4349Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 23.2527L31.7808 25.475V26.7326L31.0251 26.5646L21.7807 24.5103V24.1749V23.2527Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.025 24.007L21.7807 24.1749L31.0251 26.2292V26.5646V27.4868L21.025 25.2646V24.007Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7808 26.7326L31.0251 26.5646V27.4868L31.7808 26.7326Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7807 24.1749V23.2527L21.025 24.007L21.7807 24.1749Z",
    fill: "#4A0B82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_6888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7824,
    height: 45.6859,
    fill: "white",
    transform: "matrix(0.976187 0.21693 0 1 0 0.816406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.b7f16fdd4e50e301b4a6ac711575983b.svg";
export { ForwardRef as ReactComponent };